module.exports = __webpack_public_path__ + "img/pencil-outline-disable-v2.73ffcac1.svg";